import colors from 'styles/colors';

const styles = {
  container: (hasBanner) => ({
    margin: '24px 0',
    display: 'flex',
    alignItems: 'start',
    flexDirection: 'column',
    ...(!hasBanner && {
      '@media (min-height: 1020px)': {
        margin: '36px 0 48px 0',
      },
    }),

    ...(hasBanner && {
      '@media (max-height: 999px)': {
        margin: '12px 0',
      },
    }),
  }),
  welcomeText: {
    fontSize: '23px',
    fontWeight: 600,
    lineHeight: '100%',
    marginBottom: '10px',
  },
  button: {
    marginTop: '24px',
  },
  paper: {
    paddingTop: '40px',
    paddingBottom: '40px',
    textAlign: 'center',
  },
  title: {
    display: 'flex',
    alignItems: 'center',
  },
  stats: (hasBanner) => ({
    display: 'flex',
    padding: '24px',
    marginBottom: '24px',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '32px',
    borderRadius: '8px',
    border: '1px solid rgba(255, 255, 255, 0.10)',
    background: 'rgba(255, 255, 255, 0.04)',
    ...(!hasBanner && {
      '@media (min-height: 1020px)': {
        gap: '48px',
        marginBottom: '48px',
      },
    }),
    ...(hasBanner && {
      '@media (max-height: 999px)': {
        gap: '8px',
      },
    }),
  }),
  background: {
    height: '166px',
    padding: '24px',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '10px',
    background: 'linear-gradient(148deg, rgba(95, 56, 116, 0.8) 30%, rgba(62, 49, 119, 0.1) 60%)',
  },
  subtitle: {
    fontSize: '20px',
    fontWeight: 600,
    marginBottom: '20px',
    color: '#FFFFFF',
    opacity: '0.9',
  },
  links: {
    display: 'flex',
    padding: '24px',
    alignItems: 'center',
    borderRadius: '8px',
    border: '1px solid rgba(255, 255, 255, 0.10)',
    background: 'linear-gradient(90deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0.04) 50%, rgba(255, 255, 255, 0.02) 100%)',
    cursor: 'pointer',
  },
  linkText: {
    color: colors.text.primary,
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: '100%',
    textDecorationLine: 'underline',
    textDecorationStyle: 'solid',
    textDecorationSkipInk: 'none',
    textDecorationThickness: 'auto',
    textUnderlineOffset: 'auto',
    textUnderlinePosition: 'from-font',
  },
};
export default styles;
